import React, { Component } from "react";
import ReactDOM from 'react-dom';
import axios from "axios";

import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { LangContext } from "../LangContext.jsx";
const fieldTypes = [
    {
        id: 'RFC',
        title: 'rfc',
        icon: 'fa-font',
        document_field_type: 'text',
        index: 0,
        placeholder: 'RFC'
    },
    {
        id: 'CURP',
        title: 'curp',
        icon: 'fa-font',
        document_field_type: 'text',
        index: 1,
        placeholder: 'CURP'
    },
    {
        id: 'Nombre',
        title: 'nombre',
        icon: 'fa-font',
        document_field_type: 'text',
        index: 2,
        placeholder: 'Nombre'
    },
    {
        id: 'ApellidoPaterno',
        title: 'apellidoPaterno',
        icon: 'fa-font',
        document_field_type: 'text',
        index: 3,
        placeholder: 'Apellido paterno'
    },
    {
        id: 'ApellidoMaterno',
        title: 'apellidoMaterno',
        icon: 'fa-font',
        document_field_type: 'text',
        index: 4,
        placeholder: 'Apellido materno'
    },
    {
        id: 'FechaNacimiento',
        title: 'fechaNacimiento',
        icon: 'fa-font',
        document_field_type: 'date',
        index: 5,
        placeholder: 'Fecha de nacimiento'
    },
    {
        id: 'RazonSocial',
        title: 'razonSocial',
        icon: 'fa-font',
        document_field_type: 'text',
        index: 6,
        placeholder: 'Razón social'
    },
    {
        id: 'RegimenCapital',
        title: 'regimenCapital',
        icon: 'fa-font',
        document_field_type: 'text',
        index: 7,
        placeholder: 'Régimen capital'
    },
    {
        id: 'FechaConstitucion',
        title: 'fechaConstitucion',
        icon: 'fa-font',
        document_field_type: 'date',
        index: 8,
        placeholder: 'Fecha de constitución'
    },
    {
        id: 'FechaInicioOperaciones',
        title: 'fechaInicioOperaciones',
        icon: 'fa-font',
        document_field_type: 'date',
        index: 9,
        placeholder: 'Fecha de inicio de operaciones'
    },
    {
        id: 'SituacionContribuyente',
        title: 'situacionContribuyente',
        icon: 'fa-font',
        document_field_type: 'text',
        index: 10,
        placeholder: 'Situación del contribuyente'
    },
    {
        id: 'FechaUltimoCambioSituacion',
        title: 'fechaUltimoCambioSituacion',
        icon: 'fa-font',
        document_field_type: 'date',
        index: 11,
        placeholder: 'Fecha del último cambio de situación'
    },
    {
        id: 'EntidadFederativa',
        title: 'entidadFederativa',
        icon: 'fa-font',
        document_field_type: 'text',
        index: 12,
        placeholder: 'Entidad federativa'
    },
    {
        id: 'MunicipioDelegacion',
        title: 'municipioDelegacion',
        icon: 'fa-font',
        document_field_type: 'text',
        index: 13,
        placeholder: 'Municipio o delegación'
    },
    {
        id: 'Colonia',
        title: 'colonia',
        icon: 'fa-font',
        document_field_type: 'text',
        index: 14,
        placeholder: 'Colonia'
    },
    {
        id: 'TipoVialidad',
        title: 'tipoVialidad',
        icon: 'fa-font',
        document_field_type: 'text',
        index: 15,
        placeholder: 'Tipo de vialidad'
    },
    {
        id: 'NombreVialidad',
        title: 'nombreVialidad',
        icon: 'fa-font',
        document_field_type: 'text',
        index: 16,
        placeholder: 'Nombre de la vialidad'
    },
    {
        id: 'NumeroExterior',
        title: 'numeroExterior',
        icon: 'fa-font',
        document_field_type: 'text',
        index: 17,
        placeholder: 'Número exterior'
    },
    {
        id: 'NumeroInterior',
        title: 'numeroInterior',
        icon: 'fa-font',
        document_field_type: 'text',
        index: 18,
        placeholder: 'Número interior'
    },
    {
        id: 'CP',
        title: 'cp',
        icon: 'fa-font',
        document_field_type: 'text',
        index: 19,
        placeholder: 'Código postal'
    },
    {
        id: 'CorreoElectronico',
        title: 'correoElectronico',
        icon: 'fa-font',
        document_field_type: 'email',
        index: 20,
        placeholder: 'Correo electrónico'
    },
    {
        id: 'AL',
        title: 'al',
        icon: 'fa-font',
        document_field_type: 'text',
        index: 21,
        placeholder: 'AL (Área local)'
    },
    {
        id: 'Regimen',
        title: 'regimen',
        icon: 'fa-font',
        document_field_type: 'text',
        index: 22,
        placeholder: 'Régimen'
    },
    {
        id: 'FechaAlta',
        title: 'fechaAlta',
        icon: 'fa-font',
        document_field_type: 'date',
        index: 23,
        placeholder: 'Fecha de alta'
    }
];

   

class DocumentFieldsCFiscal extends Component {
    constructor(props) {
        super();
        this.state = {
            indexSelected: null,
            fields: fieldTypes,
            all_fields:fieldTypes
        };
        this.removeIndex = this.removeIndex.bind(this);
    }

    componentWillReceiveProps(props) {
        if (props.selected_fields != null) {
            this.setState({
                indexSelected: null,
                fields: props.selected_fields
            })
        }
    }

    onDragEnd = result => {
        if (!result.destination) return;
        for (var i = 0; i < this.state.fields.length; i++) {
            if(this.state.fields[i].index == result.source.index){
                return false;
            }
        }
        if (result.destination.droppableId == 'newField') {
            try {
                const f = {
                    id:fieldTypes[result.source.index].id,
                    document_field_type: fieldTypes[result.source.index].document_field_type,
                    title: fieldTypes[result.source.index].title,
                    index: fieldTypes[result.source.index].index,
                    placeholder: "",
                    required: false
                }
                this.setState(prevState => ({
                    fields: [...prevState.fields, f],
                    indexSelected: prevState.fields.length
                }))
            } catch (error) {
                console.log(error);
            }
        }
    }

    removeIndex(e, index) {
        e.stopPropagation();
        const fields = [...this.state.fields];
        fields.splice(index, 1);
        this.setState({ indexSelected: null, fields: fields });
    }

    render() {
        return (
            <div>
                <div className="card mt-6 p-9">
                    <strong className="mb-3">Información que se extrae de la Constancia de Situación Fiscal</strong>
                    <div className="card mt-3 p-9 bg-light-light">
                        <DragDropContext onDragEnd={this.onDragEnd}>
                            <Droppable droppableId="fields">
                                {(provided) => (
                                    <div className="row align-left" {...provided.droppableProps} ref={provided.innerRef}>
                                        <div className="col-sm-8">
                                            {this.state.fields.map(({id, document_field_type, placeholder}, index) => {
                                                return (<div key={index} className="mb-2">
                                                    <span>
                                                        <i className="fa fa-check icon text-primary mr-5 font-size-xs"></i>
                                                    </span>
                                                    <span className="d-inline-block">
                                                        {placeholder}
                                                    </span>
                                                </div>);
                                            })}

                                        </div>
                                    </div>
                                )}
                            </Droppable>
                        </DragDropContext>
                    </div>
                </div>
            </div>
        );
    }
}

export default DocumentFieldsCFiscal;

if (document.getElementById('DocumentFieldsCFiscal')) {
    ReactDOM.render(<DocumentFieldsCFiscal />, document.getElementById('DocumentFieldsCFiscal'));
}
